export const taxReturnsBaseUrl = '/taxreturns';
export const taxReturnFormsUrl = `${taxReturnsBaseUrl}/form`;
export const taxReturnFormVersionsUrl = `${taxReturnFormsUrl}/version`;
